import Header from '../../components/Header';
import Footer from '../../components/Footer';
import ProfileSidebar from '../../components/Profile/ProfileSidebar';
import MobileNavigation from '../../components/MobileNavigation';

const Profile = () => {
  return (
    <div className="flex flex-col">
      <div className="min-h-dvh">
        <Header />
        <MobileNavigation />

        <div className='max-w-[1220px] w-full mx-auto flex gap-4 lg:gap-20 py-0 lg:py-20'>
          <div className='w-full lg:w-[320px]'>
            <ProfileSidebar />
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Profile;
